export default __webpack_public_path__ + "static/media/medical.4d42a956.svg";